import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=0f09e39d"
import script from "./navItem.vue?vue&type=script&lang=js"
export * from "./navItem.vue?vue&type=script&lang=js"
import style0 from "./navItem.vue?vue&type=style&index=0&id=0f09e39d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports